import React from "react";
import "./ToggleButtonGroup.scss";

type ToggleButtonGroupProps = {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  padding?: string;
  border?: string;
  backgroundColor?: string;
  gap?: string;
  alignItems?: "center" | "flex-start" | "flex-end";
};

export const ToggleButtonGroup: React.FC<ToggleButtonGroupProps> = ({
  children,
  className,
  style,
  padding,
  border,
  backgroundColor,
  gap = "0.5rem",
  alignItems = "center",
}) => {
  return (
    <div
      className={`toggle-button-group  ${className ? className : ""}`}
      style={{
        border,
        padding,
        backgroundColor,
        ...style,
      }}
    >
     {children} 
    </div>
  );
};
